import styled from 'styled-components';

const TIB_GeneralWrapper = styled.div`
	width: 100%;
	border: 1px solid ${(props) => props.theme.color.border};
	border-radius: 4px;
	> div {
		display: flex;
		padding: 1.1em 1em;
		box-sizing: border-box;
		width: 100%;
		&:not(:last-of-type) {
			border-bottom: 1px solid ${(props) => props.theme.color.border};
		}
		/* ──── total ───────────────────────────────────────────────────────────────────────────── */
		&.total {
			img {
				width: 35px;
			}
			> div:last-of-type {
				span:last-of-type {
					font-weight: bold;
					font-size: 1.5em;
				}
			}
		}
		/* ──── create report ───────────────────────────────────────────────────────────────────── */
		&.create-report {
			button {
				border: 2px solid ${(props) => props.theme.color.primary};
				border-radius: 4px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: ${(props) => props.theme.color.primary};
				font-size: 1em;
				width: 100%;
				padding: .5em;
				font-weight: bold;
				transition: opacity .25s ease-in-out;
				span {
					margin-left: .5em;
				}
				&:hover {
					cursor: pointer;
					opacity: .7;
				}
			}
		}
	}
`;

const TIB_Sum = styled.div`
	padding-left: 0.9em;
	box-sizing: border-box;
	width: 100%;
	span {
		display: inline-block;
		width: 100%;
		font-size: 0.95em;
		&:last-of-type {
			font-size: 1.3em;
		}
	}
`;

const TIB_Img = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	img {
		width: 30px;
	}
`;

export default {
	TIB_GeneralWrapper,
	TIB_Sum,
	TIB_Img
};
